import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../../react-cognito";
import { NotificationManager } from "react-notifications";
import store from "../../../store";
import { Loader } from "../../../components/loader";
import PhoneInput from "react-phone-number-input";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-phone-number-input/style.css";
import Steps, { Step } from "rc-steps";
import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import "react-select/dist/react-select.css";
import AvatarEditor from "react-avatar-editor";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import { fetchAnimalTypes } from "../../../actions/addAnimalType";
import { fetchRegTypes } from "../../../actions/regType";
import { 
  findPetById
} from "../../../actions/medicalRecords";
import { fetchBreeders, fetchBreedCategory,fetchBreederDurartion, addBreeder, fetchBreederById  } from "../../../actions/breeders";
import { fetchAdministereds } from "../../../actions/administered";
import AddAdministeredTypeForm from "../../settings/addAdministeredType";
import { BreadCrumb } from "../../../components/breadcrumb";
import { forceInputUppercase, resizeImage } from "../../../utils/helper";

const $ = window.$;
const initialState = {
  littermate: false,
  mediModalType: "",
  country: "",
  currentStepNotValid: false,
  currentFormIncomplete: false,
  currentStep: 0,
  PetId: "",
  arrival_date: moment().toDate(),
  sex: "MALE",
  weight: "",
  loading: false,
  pet_id: "",
  breedId: "",
  new_breeder: false,
  BreederId: "N/A",
  new_b_name: "",
  new_b_usda_no: "",
  new_b_address_line_1: "",
  new_b_address_line_2: "",
  new_b_address_city: "",
  new_b_address_state: "",
  new_b_address_country: "",
  new_b_address_postal_code: "",
  new_b_phone: "",
  toa: [],
  breeds: [],
  reg_types: [],
  breeders: [],
  medications: [
    // {date:'', MedicationId:'N/A', more_info: '',medType:'vaccine', id:0},
    // {date:'', MedicationId:'N/A', more_info: '',medType:'deworm', id:1}
  ],
  // administered: [],
  dewormings: [],
  vaccinations: [],
 
  selectedPrimaryImageOption: "1",

  mediCount: 2,
  notes: "",
  showAdministered: false,
  adult_weight: null,
  breed_category_id: null,
  breeds_category: [],
  breeders_vaccine: [],
  breeders_vaccine_duration: [],
  breeder_vaccine_duration_days: "",
  breeders_vaccine_id: null,
  breeders_treatment_id: null,
  breeders_vaccine_duration_id: null,
  breeders_treatment_duration_id: null,
  breeders_assigned_vaccine: [],
  breeders_treatment: [],
  new_breederid: null,
  breedervaccinebyid: []
};
let newMedicalRecord = {};
let form_step_0 = {};
let form_step_1 = {};
let form_step_2 = {
  medications: [
    { date: "", MedicationId: "", id: 0 },
    { date: "", MedicationId: "", id: 1 }
  ]
};
class Datamodal extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;
 
  confirmMedications = medications => {
    return medications.map(item => {
      if (!moment(item.date).isValid()) {
        item.date = null;
      }
      if (item.MedicationId === "N/A") {
        item.MedicationId = null;
      }
      return item;
    });
  };

  newBreederCreate = () => { 
  
      form_step_1 = {
        newBreeder: true,
        breeder:
          this.state.new_b_name.trim().length > 0
            ? this.state.new_b_name
            : "invalid",
        usda_no:
          this.state.new_b_usda_no.toString().trim().length > 0
            ? this.state.new_b_usda_no
            : "invalid",
        addressLine1:
          this.state.new_b_address_line_1.trim().length > 0
            ? this.state.new_b_address_line_1
            : "invalid",
        addressLine2:
          this.state.new_b_address_line_2.trim().length > 0
            ? this.state.new_b_address_line_2
            : "",
        addressCity:
          this.state.new_b_address_city.trim().length > 0
            ? this.state.new_b_address_city
            : "invalid",
        addressState:
          this.state.new_b_address_state.trim().length > 0
            ? this.state.new_b_address_state
            : "invalid",
        addressCountry:
          this.state.new_b_address_country.trim().length > 0
            ? this.state.new_b_address_country
            : "invalid",
        addressPostalCode:
          this.state.new_b_address_postal_code.trim().length > 0
            ? this.state.new_b_address_postal_code
            : "invalid",
        phone:
          this.state.new_b_phone.toString().trim().length > 0
            ? this.state.new_b_phone
            : "invalid",
        breederAssignedVaccine: this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine : [],
        confirmExisting: false
      };      
      let data = Object.entries(form_step_1).map(([key, value]) => {
        if (key !== 'weight' && value === "invalid") {
          return "invalid";
        } else if (value === null) {
          return "invalid";
        } else {
          return value;
        }
      });    
      if (!data.includes("invalid")) {   
        this.props.addBreeder(form_step_1);
      } else {
        NotificationManager.warning("Please check input details again.");
        this.setState({ currentStepNotValid: true });
      }


  };

  newBreederCreateNew = () => {
    form_step_1 = {
      newBreeder: true,
      breeder:
        this.state.new_b_name.trim().length > 0
          ? this.state.new_b_name
          : "invalid",
      usda_no:
        this.state.new_b_usda_no.toString().trim().length > 0
          ? this.state.new_b_usda_no
          : "invalid",
      addressLine1:
        this.state.new_b_address_line_1.trim().length > 0
          ? this.state.new_b_address_line_1
          : "invalid",
      addressLine2:
        this.state.new_b_address_line_2.trim().length > 0
          ? this.state.new_b_address_line_2
          : "",
      addressCity:
        this.state.new_b_address_city.trim().length > 0
          ? this.state.new_b_address_city
          : "invalid",
      addressState:
        this.state.new_b_address_state.trim().length > 0
          ? this.state.new_b_address_state
          : "invalid",
      addressCountry:
        this.state.new_b_address_country.trim().length > 0
          ? this.state.new_b_address_country
          : "invalid",
      addressPostalCode:
        this.state.new_b_address_postal_code.trim().length > 0
          ? this.state.new_b_address_postal_code
          : "invalid",
      phone:
        this.state.new_b_phone.toString().trim().length > 0
          ? this.state.new_b_phone
          : "invalid",
      breederAssignedVaccine: this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine : [],
      confirmExisting: true
    };
    this.props.addBreeder(form_step_1);   
    $("#confirm_breedersave_modal").modal("hide");
  }

  changeSelectionVal = event => {
    let value = event.target.value;

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  }


  changeVal = event => {
    let excludes = ["weight", "price"];
    if (!excludes.includes(event.target.name)) forceInputUppercase(event);

    let value = event.target.value;

    if (event.target.name === 'pet_id') value = value.split(" ").join("");

    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  changeBreeder = selected => {
    if (selected) {
      this.setState({ BreederId: selected.value });
    }
  };

  changeBreederVaccine = selected => {

    if (selected) {
      this.breeder_vaccine_label = selected.label;
      this.setState({ breeders_vaccine_id: selected.value });
    }
  };

  changeBreederTreatment = selected => {
    if (selected) {
      this.breeder_treatment_label = selected.label;
      this.setState({ breeders_treatment_id: selected.value });
    }
  };

  changeBreederVaccineDuration = selected => {
    if (selected) {   
      this.breeder_vaccine_duration_label = selected.label;
      this.breeder_vaccine_duration_days = selected.days;
      this.setState({ breeders_vaccine_duration_id: selected.value });
    }
  };

  changeBreederTreatmentDuration = selected => {
    if (selected) {
      this.breeder_treatment_duration_label = selected.label;
      this.breeder_treatment_duration_days = selected.days;

      this.setState({ breeders_treatment_duration_id: selected.value });
    }
  };

  changeBreedCategory = selected => {
    if (selected) {
      this.setState({ breed_category_id: selected.value });
    }
  };

  changeAdministered = (selected, i) => {
    var index = this.state.medications.findIndex(ele => {
      return ele.id == i;
    });
    if (selected) {
      this.setState({
        medications: [
          ...this.state.medications.slice(0, index),
          Object.assign({}, this.state.medications[index], {
            MedicationName: selected.label,
            MedicationId: selected.value
          }),
          ...this.state.medications.slice(index + 1)
        ]
      });
    }
  };

  changeMedicationDate = (date, i) => {
    var index = this.state.medications.findIndex(ele => {
      return ele.id == i;
    });
    if (date) {
      this.setState({
        medications: [
          ...this.state.medications.slice(0, index),
          Object.assign({}, this.state.medications[index], { date: date }),
          ...this.state.medications.slice(index + 1)
        ]
      });
    }
  };

  changeMedicationInfo = (event, i) => {
    forceInputUppercase(event);
    var index = this.state.medications.findIndex(ele => {
      return ele.id == i;
    });
    if (i >= 0) {
      this.setState({
        medications: [
          ...this.state.medications.slice(0, index),
          Object.assign({}, this.state.medications[index], {
            [event.target.name]: event.target.value
          }),
          ...this.state.medications.slice(index + 1)
        ]
      });
    }
  };

  removeMedication = (e, id) => {
    e.preventDefault();
    var index = this.state.medications.findIndex(ele => {
      return ele.id == id;
    });
    this.setState(this.state.medications.splice(index, 1));
    // form_step_2.vaccinations.splice(id,1);
  };

  newMedication = (e, type) => {
    e.preventDefault();
    var arr = this.state.medications;
    form_step_2.medications.push({
      date: "",
      MedicationId: "",
      id: this.state.mediCount
    });
    var joined = arr.concat({
      date: "",
      MedicationId: "N/A",
      more_info: "",
      medType: type,
      id: this.state.mediCount
    });
    this.setState({ medications: joined, mediCount: this.state.mediCount + 1 });
  };

  changeDate = value => {
    this.setState({ arrival_date: value });
  };

  changeDob = value => {
    this.setState({ date_of_birth: value });
  };
  changeBreedCategory = selected => {
    if (selected) {
      this.setState({ breed_category_id: selected.value });
    }
  };

  nextStep = event => {
    this.setState({
      currentStep: this.state.currentStep + 1,
      new_breeder: this.state.new_breeder,
      currentStepNotValid: false
    });
  };

  PrevStep = event => {
    this.setState({ currentStep: this.state.currentStep - 1,});
  };
  vaccineAssignBreeder = (e) => {
    e.preventDefault();
    var arr = this.state.breeders_assigned_vaccine;
    var scheduledays = moment(this.state.date_of_birth).add(parseInt(this.breeder_vaccine_duration_days), 'd').format('YYYY-MM-DD');
    if (this.state.breeders_vaccine_duration_id > 0 && this.state.breeders_vaccine_id > 0) {

      if (this.state.breeders_vaccine_duration_id !== 'none' && this.state.breeders_vaccine_id !== 'none') {
        var joined = arr.concat({
          MedicationId: this.state.breeders_vaccine_id,
          VaccineName: this.breeder_vaccine_label,
          DurationId: this.state.breeders_vaccine_duration_id,
          DurationDays: this.breeder_vaccine_duration_days,
          Type: "vaccine",
          DurationName: this.breeder_vaccine_duration_label,
          CalAdministeredDate: scheduledays
        });
        this.setState({ breeders_assigned_vaccine: joined });
      }
      this.setState({ breeders_vaccine_id: null });
    }
    else {
      NotificationManager.warning("Please check assign vaccine values again.");
    }

  };
  treatmentAssignBreeder = (e) => {
    e.preventDefault();   
    var arr = this.state.breeders_assigned_vaccine;
    var scheduledays = moment(this.state.date_of_birth).add(parseInt(this.state.breeder_treatment_duration_days), 'd').format('YYYY-MM-DD');
    if (this.state.breeders_treatment_duration_id > 0 && this.state.breeders_treatment_id > 0) {

      if (this.state.breeders_treatment_duration_id !== 'none' && this.state.breeders_treatment_id !== 'none') {
        var joined = arr.concat({
          MedicationId: this.state.breeders_treatment_id,
          VaccineName: this.breeder_treatment_label,
          DurationId: this.state.breeders_treatment_duration_id,
          DurationDays: this.breeder_treatment_duration_days,
          Type: "deworm",
          DurationName: this.breeder_treatment_duration_label,
          CalAdministeredDate: scheduledays
        });
        this.setState({ breeders_assigned_vaccine: joined });
      }
      this.setState({ breeders_treatment_id: null });
    }
    else {
      NotificationManager.warning("Please check assign treatment values again.");
    }



  };
  deleteVaccineAssignBreeder = (e, item) => {
    e.preventDefault();
    var index = this.state.breeders_assigned_vaccine.findIndex(ele => {
      return ele.MedicationId == item.MedicationId;
    });
    this.setState(this.state.breeders_assigned_vaccine.splice(index, 1));

  };

  deleteBreederVaccines = (e, item) => {
    e.preventDefault();
    var index = this.state.breeders_assigned_vaccine.findIndex(ele => {
      return ele.MedicationId == item.MedicationId;
    });
    this.setState(this.state.breeders_assigned_vaccine.splice(index, 1));

  };

  resetState = () => {
    this.setState(initialState);
    this.props.fetchAnimalTypes();
    this.props.fetchRegTypes();
    this.props.fetchBreeders();
    this.props.fetchBreedCategory();
    this.props.fetchAdministereds();
  };

  closeModal = () => {
    $("#confirm_breedersave_modal").modal("hide");
    //this.resetState();
  };

  componentWillReceiveProps = (nextProps, prevProps) => { 

    if (nextProps.newBreederError && this.props.newBreederError !== nextProps.newBreederError) {

      if (nextProps.newBreederError.message && (nextProps.newBreederError.message === 'Breeder name already exists')) {
       
        this.openConfirmModal();
      //  NotificationManager.error(
      //     nextProps.newBreederError.message
      //   );
        this.setState({ loading: false });

      } else {
        NotificationManager.error(
          "Something went wrong when saving New Breeder"
        );
        this.resetState();
      }

    }

    if (
      nextProps.breeds &&
      this.props.breeds !== nextProps.breeds &&
      nextProps.breeds.length > 0
    ) {
      let options = [{ label: "Select Breed", value: "none" }];
      nextProps.breeds.map(p => {
        options.push({ label: p.breed_type, value: p.id });
      });
      this.setState({ breeds: options });
      if (nextProps.breeds.length > 0) {
        this.setState({ breedId: "none" });
      }
    }

    if (
      nextProps.breeders &&
      this.props.breeders !== nextProps.breeders &&
      nextProps.breeders.length > 0
    ) {
      let options = [{ label: "Select an breeder", value: "N/A" }];
      nextProps.breeders.map(p => {
        options.push({ label: p.breeder, value: p.id });
      });
      this.setState({ breeders: options });
      if (nextProps.breeders.length > 0) {
        this.setState({ BreederId: "N/A" });
      }
    }


    if (
      nextProps.administered &&
      this.props.administered !== nextProps.administered &&
      nextProps.administered.length > 0
    ) {
      let VaccinationOptions = [{ label: "Select an option", value: "N/A" }];
      let DewormingOptions = [{ label: "Select an option", value: "N/A" }];

      nextProps.administered.map(p => {
        if (p.type === "vaccine") {
          VaccinationOptions.push({ label: p.name, value: p.id });
        }
        if (p.type === "deworm") {
          DewormingOptions.push({ label: p.name, value: p.id });
        }
      });

      this.setState({
        vaccinations: VaccinationOptions,
        dewormings: DewormingOptions,
        breeders_treatment: DewormingOptions,
        breeders_vaccine: VaccinationOptions,
      });

      if (nextProps.administered.length > 0) {
        this.state.medications.map((v, i) => {
          this.setState({
            medications: [
              ...this.state.medications.slice(0, i),
              Object.assign({}, this.state.medications[i], {
                MedicationId: "N/A"
              }),
              ...this.state.medications.slice(i + 1)
            ]
          });
        });
      }
    } 

    if (
      this.props.data.administeredTypeReducer.setAdministered !==
      nextProps.data.administeredTypeReducer.setAdministered
    ) {
      this.props.fetchAdministereds();
    }  

    if (
      nextProps.newBreeder &&
      this.props.newBreeder !== nextProps.newBreeder
    ) {
      let arr = this.state.breeders;  
      arr.push({ label: nextProps.newBreeder.breeder, value: nextProps.newBreeder.id });
     // this.setState({ new_breederid: nextProps.newBreeder.id, breeders: arr });
      this.setState({
        b_phone: nextProps.newBreeder.phone ? nextProps.newBreeder.phone : "",
        b_usda: nextProps.newBreeder.usda_no ? nextProps.newBreeder.usda_no : "",
        b_address_line_1: nextProps.newBreeder.addressLine1 ? nextProps.newBreeder.addressLine1 : "",
        b_address_line_2: nextProps.newBreeder.addressLine2 ? nextProps.newBreeder.addressLine2 : "",
        b_address_city: nextProps.newBreeder.addressCity ? nextProps.newBreeder.addressCity : "",
        b_address_state: nextProps.newBreeder.addressState ? nextProps.newBreeder.addressState : "",
        b_address_country: nextProps.newBreeder.addressCountry ? nextProps.newBreeder.addressCountry : "",
        b_address_postal_code: nextProps.newBreeder.addressPostalCode
          ? nextProps.newBreeder.addressPostalCode
          : "",
        BreederId: nextProps.newBreeder.id ? nextProps.newBreeder.id : "",
      });

      NotificationManager.success("Breeder added succesfully.");

    }

    if (
      nextProps.breeders_vaccine_duration &&
      this.props.breeders_vaccine_duration !== nextProps.breeders_vaccine_duration &&
      nextProps.breeders_vaccine_duration.length > 0
    ) {
      let options = [{ label: "Select Interval", value: "none" }];
      nextProps.breeders_vaccine_duration.map(p => {
        options.push({ label: p.label, value: p.id, days: p.days });
      });
      this.setState({ breeders_vaccine_duration: options });
      if (nextProps.breeders_vaccine_duration > 0) {
        this.setState({ breeders_vaccine_duration_id: "none" });
      }
    }

    if (
      nextProps.breedervaccinebyid &&
      this.props.breedervaccinebyid !== nextProps.breedervaccinebyid &&
      nextProps.breedervaccinebyid.length > 0
    ) {    
      let vaccine = nextProps.breedervaccinebyid;
      let arr = []
      vaccine.map(item => {
        // var scheduledays = moment(newMedicalRecord.dob).add(parseInt(item.DurationDays), 'd').format('YYYY-MM-DD');
        let form = {
          ...item,
          CalAdministeredDate: moment(this.state.date_of_birth).add(parseInt(item.DurationDays), 'd').format('YYYY-MM-DD')

        }
        arr.push(form);
      })
      this.setState({ breeders_assigned_vaccine: arr })

    }

    if (
      nextProps.breeds_category &&
      this.props.breeds_category !== nextProps.breeds_category &&
      nextProps.breeds_category.length > 0
    ) {
      let options = [{ label: "Select Welcome Email", value: "none" }];
      nextProps.breeds_category.map(p => {    
        options.push({ label: p.name, value: p.id });
      });
      this.setState({ breeds_category: options });
      if (nextProps.breeds_category.length > 0) {
        this.setState({ breed_category_id: "none" });
      }
    }

    if (this.props.newRecord !== nextProps.newRecord) {
      if (nextProps.newRecord.mc_status === "draft") {
        NotificationManager.warning("Medical Record saved as draft.");
      }
      if (nextProps.newRecord.mc_status === "complete") {
        NotificationManager.success("Medical Record added succesfully.");
      }
      if (!this.state.littermate) {
        this.resetState();
        this.nextStep();
      } else {
        this.setState({
          loading: false,
          currentStep: 0,
          pet_id: "",
          micro_chip: "",
          weight: "",

          // Image 01
          imgSrc01: "",
          imgName01: "",
          zoom01: 1.5,
          editor01: "",
          rotate01: 0,

          // Image 02
          imgSrc02: "",
          imgName02: "",
          zoom02: 1.5,
          editor02: "",
          rotate02: 0,

          // Image 03
          imgSrc03: "",
          imgName03: "",
          zoom03: 1.5,
          editor03: "",
          rotate03: 0,

          // Image 04
          imgSrc04: "",
          imgName04: "",
          zoom04: 1.5,
          editor04: "",
          rotate04: 0,

          // Image 05
          imgSrc05: "",
          imgName05: "",
          zoom05: 1.5,
          editor05: "",
          rotate05: 0,

          //reset sex
          sex: ""
        });
      }
    }
  };

  componentDidMount = () => {
    this.props.fetchAnimalTypes();
    this.props.fetchRegTypes();
    this.props.fetchBreeders();
    this.props.fetchAdministereds();
    this.props.fetchBreedCategory();
    this.props.fetchBreederDurartion();
    this.setState({ country: this.props.petShop.currentPetshop.country });
  };

  componentDidUpdate = (prevProps, prevState) => { 

    if (this.props.data.breederReducer.breedervaccineinfo !==
      prevProps.data.breederReducer.breedervaccineinfo) {
      let vaccine = this.props.data.breederReducer.breedervaccineinfo;
      let arr = []
      vaccine.map(item => {
        let form = {
          ...item,
          CalAdministeredDate: moment(newMedicalRecord.dob).add(parseInt(item.DurationDays), 'd').format('YYYY-MM-DD')
  
        }
        arr.push(form);
      })
      this.setState({ breeders_assigned_vaccine: arr })
  
    }
  
  }; 
 
  findMedicationId = id => {
    var index = form_step_2.medications.findIndex(ele => {
      return ele.id == id;
    });
    if ((index = -1)) {
      return 0;
    }
    return index;
  };

  AddNewAdministered = (e, type) => {
    e.preventDefault();
    this.setState({ mediModalType: type, showAdministered: true });
    // $("#add_administered_type").modal("show");
  };
  openConfirmModal = () => {   
    $("#confirm_breedersave_modal").modal("show");
  };
  items = [
    { title: "Breeders", to: "/breeders" },
    { title: "New Breeder", to: "/breeders/add"}
  ];
  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }
  render() {
    const {     
      country,
      currentStep,    
      pet_id,
      PetId,
      breedId,  
      sex,
      RegistrationTypeId,
      sire,
      sire_number,
      dam,
      dam_number,
      new_breeder,
      BreederId,
      b_usda,
      b_address_line_1,
      b_address_line_2,
      b_address_city,
      b_address_state,
      b_address_country,
      b_address_postal_code,
      b_phone,
      new_b_name,
      new_b_usda_no,
      new_b_address_line_1,
      new_b_address_line_2,
      new_b_address_city,
      new_b_address_state,
      new_b_address_country,
      new_b_address_postal_code,
      new_b_phone,
      medications,
      vaccinations,
      dewormings,
      weight,
      currentFormIncomplete,
      mediModalType,
      notes,
      showAdministered,
      adult_weight,
      breed_category_id,
      breeds_category,
      breeders_vaccine,
      breeders_vaccine_id,
      breeders_treatment,
      breeders_treatment_id,
      breeders_vaccine_duration,
      breeders_vaccine_duration_id,
      breeders_treatment_duration_id,
      breeders_assigned_vaccine,
     // breeder_treatment_duration_label,
     // breeder_treatment_duration_days
    } = this.state; 
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--lg m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        New Breeder
                        <small>
                          Complete this form to add a breeder
                        </small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-wizard m-wizard--1 m-wizard--success">             
                  <div className="m-wizard__form">
                    <form
                      onSubmit={this.submit}
                      className="m-form m-form--label-align-left- m-form--state-"
                    >
                      <div className="m-portlet__body m-portlet__body_grey">                
                        <div id={"form-step1"}>
                            <div className="row">
                              <div className="col-xl-8 offset-xl-2 col-md-8 offset-md-2">
                                                   
                                  <div className="m-form__section">
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Breeder:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_name}
                                            name="new_b_name"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.breederName ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the breeder name
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          USDA Number:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_usda_no}
                                            name="new_b_usda_no"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.usdaNo === "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the USDA number
                                        </span>
                                        </div>
                                      </div>

                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Line 1:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_line_1}
                                            name="new_b_address_line_1"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressLine1 ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the Address Line 1
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Line 2:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_line_2}
                                            name="new_b_address_line_2"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressLine2 ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the Address Line 2
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address City:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_city}
                                            name="new_b_address_city"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressCity ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the City
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address State:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_state}
                                            name="new_b_address_state"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressState ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the State
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Country:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_country}
                                            name="new_b_address_country"
                                            className="form-control m-input"
                                            onChange={this.changeVal}
                                          />
                                          <span
                                            className={
                                              form_step_1.addressCountry ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the Country
                                        </span>
                                        </div>
                                      </div>
                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Address Postal Code:
                                      </label>
                                        <div className="col-lg-6">
                                          <input
                                            type="text"
                                            value={new_b_address_postal_code}
                                            name="new_b_address_postal_code"
                                            onChange={this.changeVal}
                                            className="form-control m-input"
                                          />
                                          <span
                                            className={
                                              form_step_1.addressPostalCode ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            {" "}
                                          Enter the Postal Code
                                        </span>
                                        </div>
                                      </div>

                                      <div className="form-group m-form__group row">
                                        <label className="col-lg-4 col-form-label">
                                          Breeder's Phone:
                                      </label>
                                        <div className="col-lg-6">
                                          <PhoneInput
                                            country={country}
                                            className="form-control"
                                            placeholder="Enter the breeder's phone"
                                            value={new_b_phone}
                                            onChange={value =>{ 
                                             if(value){                                      
                                              this.setState({
                                                new_b_phone: value
                                              })  
                                            }
                                            else{
                                              this.setState({
                                                new_b_phone: ""
                                              }) 
                                            }                                                                                     
                                            }
                                          }
                                          />
                                          <span
                                            className={
                                              form_step_1.breederPhone ===
                                                "invalid" &&
                                                this.state.currentStepNotValid
                                                ? "m-form__help_danger"
                                                : "display-none"
                                            }
                                          >
                                            Enter the breeder's phone
                                        </span>
                                        </div>
                                      </div>
                                      <div className="m-accordion__item m-accordion__item--danger" style={{
                                        paddingBottom: "50px", border: "1px dotted", padding: "25px",
                                        marginBottom: "35px"
                                      }}>
                                        <div className="m-accordion__item-head collapsed" srole="tab" id="m_accordion_5_item_1_head" data-toggle="collapse" href="#m_accordion_5_item_1_body" aria-expanded="false">

                                          <span className="m-accordion__item-title" style={{ fontSize: "14px" }}>Vaccine Schedule</span>
                                          <span className="m-accordion__item-icon" style={{ paddingLeft: "10px" }}><i className="la la-long-arrow-down"></i>
                                          </span>
                                        </div>
                                        <div className="m-accordion__item-body collapse" id="m_accordion_5_item_1_body" role="tabpanel" aria-labelledby="m_accordion_5_item_1_head" data-parent="#m_accordion_5">
                                          <div className="panel-body">
                                            <div className="m-form__section">
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Interval:
                                                </label>
                                                <div className="col-lg-6 col-12">
                                                  <Select
                                                    options={breeders_vaccine_duration}
                                                    value={breeders_vaccine_duration_id}
                                                    name="breeders_vaccine_duration_id"
                                                    onChange={this.changeBreederVaccineDuration}
                                                    placeholder="Select the Timeline"
                                                  />

                                                </div>
                                              </div>

                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Vaccination Name:
                                                </label>
                                                <div className="col-lg-6 col-10" >
                                                  <Select
                                                    options={breeders_vaccine}
                                                    value={breeders_vaccine_id}
                                                    name="breeders_vaccine_id"
                                                    onChange={this.changeBreederVaccine}
                                                    placeholder="Select the Vaccine"
                                                  />
                                                </div>
                                                <div className="col-lg-2 col-2">
                                                  <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#add_administered_type"
                                                    className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                                    onClick={e =>
                                                      this.AddNewAdministered(
                                                        e,
                                                        "vaccine"
                                                      )
                                                    }
                                                  >
                                                    <i className="la la-plus"></i>
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="row">                                         
                                                <div className="col-lg-2 offset-lg-5 offset-2">
                                                  <button
                                                    type="button"
                                                    onClick={e =>
                                                      this.vaccineAssignBreeder(e)
                                                    }
                                                    className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                                    style={{ margin: "auto" }}

                                                  >
                                                    <span>
                                                      <span> Add to Schedule </span>
                                                    </span>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="m-widget4">
                                              {this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine.filter(p => {
                                                return p.Type === "vaccine";
                                              }).map((vac) => (
                                                <div className="form-group">
                                                  <hr style={{ borderTop: "1px dashed" }}></hr>
                                                  <div className="col-12 m-widget4__item">
                                                    <div className="row">
                                                      <div className="col-4">
                                                        <div className="m-widget4__info">
                                                          <span className="m-widget4__text">
                                                            {vac.DurationName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-6" style={{ borderLeft: "2px solid" }}>
                                                        <div className="m-widget4__info" style={{ display: "inline-block", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                          <span className="m-widget4__text">
                                                            {vac.VaccineName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-2">
                                                        <div className="m-widget4__ext">
                                                          <i className="la la-times-circle" onClick={e =>
                                                            this.deleteVaccineAssignBreeder(e, vac)
                                                          } ></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>


                                              )) : null

                                              }
                                              {/* <hr style={{ border: "1px dashed" }}></hr> */}
                                            </div>

                                          </div>

                                        </div>
                                      </div>
                                      <div className="m-accordion__item m-accordion__item--danger" style={{
                                        paddingBottom: "50px", border: "1px dotted", padding: "25px",
                                        marginBottom: "35px"
                                      }} >
                                        <div className="m-accordion__item-head collapsed" srole="tab" id="m_accordion_5_item_1_head" data-toggle="collapse" href="#Treatmet_1" aria-expanded="false">

                                          <span className="m-accordion__item-title" style={{ fontSize: "14px" }}>Treatment Schedule</span>
                                          <span className="m-accordion__item-icon" style={{ paddingLeft: "10px" }}><i className="la la-long-arrow-down"></i>
                                          </span>
                                        </div>
                                        <div className="m-accordion__item-body collapse" id="Treatmet_1" role="tabpanel" aria-labelledby="m_accordion_5_item_1_head" data-parent="#m_accordion_5">
                                          <div className="panel-body">
                                            <div className="m-form__section">
                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Interval:
                                                </label>
                                                <div className="col-lg-6 col-12">                                            
                                                  <Select
                                                    options={breeders_vaccine_duration}
                                                    value={breeders_treatment_duration_id}
                                                    name="breeders_treatment_duration_id"
                                                    onChange={this.changeBreederTreatmentDuration}
                                                    placeholder="Select the Timeline"
                                                  />
                                                </div>
                                              </div>

                                              <div className="form-group m-form__group row">
                                                <label className="col-lg-4 col-12 col-form-label">
                                                  Treatment Name:
                                                </label>
                                                <div className="col-lg-6 col-10">
                                                  <Select
                                                    options={breeders_treatment}
                                                    value={breeders_treatment_id}
                                                    name="breeders_treatment_id"
                                                    onChange={this.changeBreederTreatment}
                                                    placeholder="Select the Treatment"
                                                  />
                                                </div>
                                                <div className="col-lg-2 col-2">
                                                  <a
                                                    href="#"
                                                    data-toggle="modal"
                                                    data-target="#add_administered_type"
                                                    className="btn btn-outline-success m-btn m-btn--icon m-btn--outline-2x m-btn--icon-only"
                                                    onClick={e =>
                                                      this.AddNewAdministered(
                                                        e,
                                                        "deworm"
                                                      )
                                                    }
                                                  >
                                                    <i className="la la-plus"></i>
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="row">
                                                <div className="col-lg-2 offset-lg-5 offset-2">
                                                  <button
                                                    type="button"
                                                    onClick={e =>
                                                      this.treatmentAssignBreeder(e)
                                                    }
                                                    className="btn m-btn--pill btn-outline-primary btn-sm mx-2"
                                                    style={{ margin: "auto" }}

                                                  >
                                                    <span>
                                                      <span> Add to Schedule </span>
                                                    </span>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="m-widget4">
                                              {this.state.breeders_assigned_vaccine.length > 0 ? this.state.breeders_assigned_vaccine.filter(p => {
                                                return p.Type === "deworm";
                                              }).map((vac, i) => (
                                                <div className="form-group" key={i}>
                                                  <hr style={{ borderTop: "1px dashed" }}></hr>
                                                  <div className="col-12 m-widget4__item">
                                                    <div className="row">
                                                      <div className="col-4">
                                                        <div className="m-widget4__info">
                                                          <span className="m-widget4__text">
                                                            {vac.DurationName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-6" style={{ borderLeft: "2px solid" }}>
                                                        <div className="m-widget4__info" style={{ display: "inline-block", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                          <span className="m-widget4__text">
                                                            {vac.VaccineName}
                                                          </span>
                                                        </div>
                                                      </div>
                                                      <div className="col-2">
                                                        <div className="m-widget4__ext">
                                                          <i className="la la-times-circle" onClick={e =>
                                                            this.deleteVaccineAssignBreeder(e, vac)
                                                          } ></i>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>

                                              )) : null

                                              }

                                            </div>

                                          </div>

                                        </div>
                                      </div>
                                    
                                    </div>
                             
                              </div>
                            </div>
                          </div>                    
                      </div>
                       <div className="m-portlet__foot">
                          <div className="row">
                            <div className="col-lg-12">
                              {this.state.loading == false ? (
                                <div
                                  className="row"
                                  style={{ justifyContent: "flex-end" }}
                                >  
                            
                                   <div>
                                      <button
                                        type="button"
                                        onClick={this.newBreederCreate}
                                        // onClick={this.openConfirmModal}
                                        className="btn btn-primary m-btn--pill mx-2 mt-2"
                                      >
                                        <span>
                                          &nbsp;&nbsp;
                                          <span>Add New Breeder</span>
                                          &nbsp;&nbsp;
                                          {/* <i className="la la-arrow-right"></i> */}
                                        </span>
                                      </button>
                                    </div>                             
                          
                                </div>
                              ) : (
                                  <div className="center-row">
                                    <Loader size={50} />
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>                
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_breedersave_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  WARNING
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>A breeder already exists with the same name and city. Are you sure you want to continue?</p>
              </div>
              <div className="modal-footer">
                <div>
                  <button
                    type="button"
                    onClick={() => this.closeModal()}
                    className="btn btn-secondary m-btn--pill mx-2"
                    data-dismiss="modal"
                  >
                    Cancel
                    </button>
                  <button
                    type="button"
                    onClick={() => this.newBreederCreateNew()}
                    className="btn btn-primary m-btn--pill"
                  >
                    Create
                    </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddAdministeredTypeForm type={mediModalType} />  
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  petShop: state.petShopReducer,
  administered: state.administeredTypeReducer.administeredList, 
  data: state, 
  breedTypesError: state.addBreedTypeReducer.breedTypesError,
  administeredListError: state.administeredTypeReducer.administeredListError,
  breedeListError: state.breederReducer.breederListError,
  breeds_category: state.breederReducer.breederCategory,
  breeders_vaccine_duration: state.breederReducer.breederVaccineDuration,
  //breeders_treatment: state.breederReducer.breederTreatment,
  newBreeder: state.breederReducer.newBreeder,
  newBreederError: state.breederReducer.newBreederError,
  breedervaccinebyid: state.breederReducer.breedervaccineinfo

});

const mapDispatchToProps = dispatch => ({
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchRegTypes: () => {
    dispatch(fetchRegTypes());
  },
  fetchBreeders: () => {
    dispatch(fetchBreeders());
  },
  fetchAdministereds: () => {
    dispatch(fetchAdministereds());
  },
  fetchBreedCategory: () => {
    dispatch(fetchBreedCategory());
  },
  fetchBreederDurartion: () => {
    dispatch(fetchBreederDurartion());
  },
  addBreeder: breeder => {
    dispatch(addBreeder(breeder));
  },
  fetchBreederById: id => {
    dispatch(fetchBreederById(id));
  },
  findPetById: id => {
    dispatch(findPetById(id));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Datamodal)
);